import { render } from "./NavbarToggleButton.vue?vue&type=template&id=46c45dca"
import script from "./NavbarToggleButton.vue?vue&type=script&lang=js"
export * from "./NavbarToggleButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qinzilie/INFURA-UI/infura-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__